angular.module('psModule')
    .directive('topnav', function() {
        return {
            template:'<nav class="navbar navbar-default" ng-class="{\'no-bottom-margin\': isLoggedOut()}" role="navigation"><div class="container-fluid"><div class="navbar-header"><button ng-if="!hideMenu()" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a ng-if="!hideMenu()" class="navbar-brand mm-logo" ui-sref="home"><img class="img-responsive mm-logo-size" src="/ps/resources/img/MM_neg.svg" alt="Max Matthiessen logotype"></a> <span ng-if="hideMenu()" class="navbar-brand mm-logo"><img class="img-responsive mm-logo-size" src="/ps/resources/img/MM_neg.svg" alt="Max Matthiessen logotype"></span></div><div ng-if="hideMenu()" class="navbar-collapse bs-navbar-collapse"><ul class="nav navbar-nav navbar-right"><ps-language-selector></ps-language-selector></ul></div><div ng-if="!hideMenu()" class="collapse navbar-collapse bs-navbar-collapse" id="bs-example-navbar-collapse-1"><ul class="nav navbar-nav"><li uib-dropdown ui-sref-active="active" ng-if="user.fullAccess"><a uib-dropdown-toggle><span translate="ps_insurance_pension_nav"></span> <i class="fa fa-caret-down"></i></a><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a ui-sref="fbesked" translate="ps_fbesked_nav"></a></li><li><a ui-sref="premiums" translate="ps_premie_nav"></a></li><li><a ui-sref="gruppforsakring" translate="ps_group_insurance_nav"></a></li></ul></li><li uib-dropdown ui-sref-active="active" ng-if="user.fullAccess"><a uib-dropdown-toggle data-toggle="dropdown"><span translate="ps_capital_nav"></span> <i class="fa fa-caret-down"></i></a><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a ui-sref="kapital" translate="ps_assets_nav"></a></li><li><a ui-sref="fundinfo" translate="ps_fundHistory_nav"></a></li><li><a ui-sref="fondbyte" translate="ps_fb_nav"></a></li><li><a ui-sref="maxfonder" translate="ps_maxfonder_nav"></a></li><li><a ui-sref="portfolios" translate="ps_model_portfolio_nav"></a></li><li ng-if="useSecurities()"><a ui-sref="customportfolioanalysis" translate="ps_custom_portfolio_analysis_nav"></a></li></ul></li><li ui-sref-active="active" ng-if="showSigningPageMenu()"><a ui-sref="signing"><span translate="ps_home_signing_header"></span></a></li><li uib-dropdown ui-sref-active="active"><a ui-sref="documents" uib-dropdown-toggle data-toggle="dropdown"><span translate="ps_documents_nav"></span><i ng-hide="customerViewDocumentlListIsActive() || unreadMessages === 0 || user.broker !== false" class="fa fa-envelope" aria-hidden="true"></i> <span class="unreadMessagesPositioning" ng-hide="customerViewDocumentlListIsActive() || unreadMessages === 0 ||user.broker !== false"><span class="unreadMessages">{{unreadMessages}}</span></span></a></li></ul><ul class="nav navbar-nav navbar-right"><ps-language-selector></ps-language-selector><li uib-dropdown ui-sref-active="active"><a uib-dropdown-toggle data-toggle="dropdown"><span translate="ps_support_nav"></span> <i class="fa fa-caret-down"></i></a><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a ui-sref="supportFaq" translate="ps_faq_nav"></a></li><li><a ui-sref="supportContact" translate="ps_contact_nav"></a></li><li><a ui-sref="supportLinks" translate="ps_links_nav"></a></li><li ps-sub-menu-toggle><a href="#"><span translate="ps_about_nav"></span> <i class="fa" ng-class="{\'fa-caret-right\': !show, \'fa-caret-down\': show}"></i></a><ul class="sub-menu list-unstyled" style="display: none;"><li ng-if="user.fullAccess"><a ui-sref="aboutIntro" translate="ps_intro_nav"></a></li><li><a ui-sref="aboutForhandsinformation" translate="ps_forhandsinformation_nav"></a></li><li><a ui-sref="aboutSecurity" translate="ps_security_nav"></a></li><li><a ui-sref="aboutTermsAndConditions" translate="ps_terms_and_conditions_nav"></a></li><li><a ui-sref="aboutGdpr" translate="ps_gdpr_nav"></a></li><li><a ui-sref="aboutRisk" translate="ps_risk_nav"></a></li><li><a ui-sref="aboutMaxm" translate="ps_maxm_nav"></a></li></ul></li></ul></li><li uib-dropdown><a uib-dropdown-toggle data-toggle="dropdown">{{user.name}} <i class="fa fa-caret-down"></i></a><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li ng-show="user.broker" ng-click="activeMenu = \'user\'"><a href="#" ng-click="requestIdentification()" translate="ps_bankidrequest_nav"></a></li><li ng-click="activeMenu = \'user\'"><a href="#/my-profile" translate="ps_profile_nav"></a></li><li ng-show="user.broker" ng-click="activeMenu = \'user\'"><a ui-sref="identifications" translate="ps_bankididentifications_nav"></a></li><li ng-click="activeMenu = \'user\'"><a href="#" ng-click="logout()" translate="ps_logout_nav"></a></li></ul></li></ul></div></div></nav><ps-login-image></ps-login-image><message-handler></message-handler>',
            controller: 'TopNavCtrl'
        };
    })
    .controller('TopNavCtrl', function TopNavCtrl($scope, $translate, $window, $http, $state, hideMenuService, $rootScope, LoginService, LogoutService, $uibModal, identificationService, DocumentStatefulService, AlertService, $location) {

        $scope.hideMenu = hideMenuService.hideMenu;
        $scope.isLoggedOut = LoginService.isLoggedOut;

        $rootScope.$on('$rootScope:$emit:toggledRead', function(event, data){
            $scope.unreadMessages = data;
        });

        // When a user logs in
        $rootScope.$on('$rootScope:$emit:login', function(){
            DocumentStatefulService.getYourDocuments().then(
                function(data){
                    $scope.unreadMessages = data.unreadDocuments.length;
                }
            );
        });

        $scope.unreadMessages = 0;

        // When a broker is logged in via a sso shiro token.
        $rootScope.$on('$rootScope:$emit:config-ok', function(){
            DocumentStatefulService.getYourDocuments().then(
                function(data){
                    $scope.unreadMessages = data.unreadDocuments.length;
                }
            );
        });
        $scope.showSigningPageMenu = function() {
            return $scope.showSigningPage = $scope.$root.config && $scope.$root.config.toggles && $scope.$root.config.toggles.SHOW_SIGNING_PAGE_MENU === true;
        };
        $scope.logout = function() {
            LogoutService.logout();
        };

        $scope.openFaktainsamling = function() {
            let language = $translate.use();
            if ($rootScope.config) {
                $scope.fiLinkUrl = $rootScope.config.faktainsamlingurl + "?lang=" + language;
                $scope.fiLinkTarget = ($scope.fiLinkUrl && $scope.fiLinkUrl.includes("http")) ? "_blank" : "_self"
                window.open($scope.fiLinkUrl, $scope.fiLinkTarget);
                if ($scope.fiLinkTarget !== "_self"){
                    $location.path("home");
                }
            } else {
                console.error("Saknar url till faktainsamlingen!");
            }
        };

        $scope.useSecurities = () => {
            return $scope.$root.config && $scope.$root.config.toggles && $scope.$root.config.toggles.USE_SECURITIES === true;
        }

        function stopIdentificationAndClosePopup() {
            identificationService.cancelPoll();
            if ($scope.modalOpen) {
                $scope.popup.close();
            }
        }

        var handleIdentResponse = function(response) {
            if (response.isError) {
                handleIdentResponseError(response);
                return;
            }

            if (response.status === 'COMPLETE') {
                handleComplete(response);
            }
        };

        var handleComplete = function(response) {
            stopIdentificationAndClosePopup();

            //Creates array needed for MultipleButtonModal
            $scope.buttonArray = [];

            $translate("ps_bankidrequest_popupbutton_success").then(function(buttonText) {
                $scope.buttonArray.push({
                    text: buttonText,
                    class: "btn-default"
                });
            });

            $translate('ps_' + response.status + '_popupText').then(function(body) {
                $translate('ps_bankidrequest_popupheader_success').then(function(headerText) {
                    $uibModal.open({
                        template:'<div><div class="modal-header" ng-if="header"><h2 class="modal-title"><img class="header-icon" ng-if="headerIcon" ng-src="{{headerIcon}}">{{header | translate}}</h2></div><div class="modal-body"><div ng-bind-html="body"></div></div><div class="modal-footer"><button ng-repeat="button in buttonArray" ng-click="buttonClicked(button);" class="{{button.class}} btn">{{button.text}}</button></div></div>',
                        controller: 'MultipleButtonsModalCtrl',
                        size: 'lg',
                        resolve: {
                            header: function() {
                                return headerText;
                            },
                            body: function() {
                                return body;
                            },
                            buttonArray: function() {
                                return $scope.buttonArray;
                            },
                            headerIcon: function() {
                                return "././img/icons/tick.png";
                            }
                        }

                    });
                });
            });
        };

        var handleIdentResponseError = function(response) {
            stopIdentificationAndClosePopup();

            //If the popup was closed: prevent error popup
            if (!$scope.modalOpen) {
                return;
            }

            //Creates button array for MultipleButtonModal
            $scope.errorButtonArray = [];

            $translate("ps_bankidrequest_popupbuttonabort_error").then(function(buttonText) {
                $scope.errorButtonArray.push(
                    $scope.abortButton = {
                        text: buttonText,
                        class: "btn-default"
                    }
                );
            });

            $translate("ps_bankidrequest_popupbuttonretry_error").then(function(buttonText) {
                $scope.errorButtonArray.push(
                    $scope.retryButton = {
                        text: buttonText,
                        class: "btn-primary"
                    }
                );
            });

            $translate('ps_bankidrequest_popupheader_error').then(function(headerText) {
                $translate('ps_' + response.status + '_popupText').then(function(buttonText) {
                    $scope.errorPopup = $uibModal.open({
                        template:'<div><div class="modal-header" ng-if="header"><h2 class="modal-title"><img class="header-icon" ng-if="headerIcon" ng-src="{{headerIcon}}">{{header | translate}}</h2></div><div class="modal-body"><div ng-bind-html="body"></div></div><div class="modal-footer"><button ng-repeat="button in buttonArray" ng-click="buttonClicked(button);" class="{{button.class}} btn">{{button.text}}</button></div></div>',
                        controller: 'MultipleButtonsModalCtrl',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            header: function() {
                                return headerText;
                            },
                            body: function() {
                                return buttonText;
                            },
                            buttonArray: function() {
                                return $scope.errorButtonArray;
                            },
                            headerIcon: function() {
                                return "././img/icons/error.png";
                            }
                        }
                    });

                    //Checks if the user wish too try again or to abort the identification
                    $scope.errorPopup.result.then(function(result) {
                        if (JSON.stringify($scope.errorButtonArray[result]) === JSON.stringify($scope.retryButton)) {
                            $scope.requestIdentification();
                        }
                    });
                });
            });
        };

        $scope.requestIdentification = function() {
            identificationService.identBid(handleIdentResponse, handleIdentResponseError);
            //Flag too keep track of if the spinner popup has been closed
            $scope.modalOpen = true;

            $translate('ps_bankidrequest_popupheader_waiting').then(function(headerText) {
                $translate('ps_bankidrequest_popupbutton_waiting').then(function(buttonText) {
                    $scope.popup = $uibModal.open({
                        template:'<div><div class="modal-header" ng-if="header"><h2 class="modal-title">{{header | translate}}</h2></div><div class="modal-body"><div style="height: 100px; line-height: 100px;"><div ng-class="loaderClass" class="text-center"><div class="text-muted"><span><i class="fa-3x fa fa-spinner fa-spin text-muted"></i></span></div></div></div></div><div class="modal-footer"><button class="btn btn-default" ng-click="buttonClicked()">{{buttonText | translate}}</button></div></div>',
                        controller: 'SpinnerModalCtrl',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            header: function() {
                                return headerText;
                            },
                            buttonText: function() {
                                return buttonText;
                            }
                        }
                    });

                    $scope.popup.result.finally(function() {
                        $scope.modalOpen = false;
                    });
                });
            });

        };

        $scope.customerViewDocumentlListIsActive = () => (
                $scope.$root.config &&
                $scope.$root.config.toggles &&
                $scope.$root.config.toggles.USE_CUSTOMER_VIEW_DOCUMENT_LIST === true
            ) ||
            $location.search().useCustomerViewDocumentList === '1';


        var alertResponse = AlertService.getMessage();
        alertResponse.$promise.then(
            function (response) {
                $rootScope.alertMessage = response.alertMessage;
                if($translate.use() === 'en') {
                    $rootScope.alertInfo = response.alertMessage.messageEN;
                } else {
                    $rootScope.alertInfo = response.alertMessage.messageSV;
                }
            });
    })
    .factory('hideMenuService', function($location, LoginService) {
        return {
            hideMenu: function() {
                const routesWithNoMenu = ['funddetails', 'portfolioanalysis'];
                return LoginService.isLoggedOut() || _.some(routesWithNoMenu, (route) => $location.path().indexOf(route) > -1);
            }
        };
    })
    .directive('psSubMenuToggle', function() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                scope.show = false;
                var submenu = angular.element(element);
                var toggler = submenu.children('a');
                var items = angular.element(submenu.children('ul'));

                angular.element(toggler).on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    scope.$apply(scope.show = !scope.show);
                    if (scope.show) {
                        items.show();
                    } else {
                        items.hide();
                    }
                });

                angular.element(items).on('click', 'li', function() {
                    scope.$apply(scope.show = false);
                    items.hide();
                });
            }
        };
    })
    .directive('psAuth', function(StorageService) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                scope.token = StorageService.getPsToken();
            }
        };
    });
